import { EcommerceAPIApi as EcommerceApi, UserAddress } from '@parkingbase/ecommerce-api-test';
import { BaseApiService } from './baseApi.service';

export class AddressService extends BaseApiService {
  protected userApi: EcommerceApi;

  constructor() {
    super();
    this.userApi = new EcommerceApi(this.apiConfig, undefined, this.apiClient);
  }

  private withDefaultValues(address: UserAddress) {
    return {
      ...address,
      addressName: address.addressName || `Address in ${address.city}`,
    };
  }

  async getUserAddress() {
    const response = await this.userApi.getUserAddress();
    return response.data;
  }

  async createUserAddress(address: UserAddress) {
    const response = await this.userApi.createAddress(this.withDefaultValues(address));
    return response.data;
  }

  async updateUserAddress(address: UserAddress) {
    const response = await this.userApi.updateAddress(address.documentId as string, address);
    return response.data;
  }

  async deleteUserAddress(id: string) {
    const response = await this.userApi.deleteAddress(id);
    return response.data;
  }
}
